import { Component, Input } from '@angular/core';

@Component({
  selector: 'liberro-contact-detail',
  standalone: false,
  templateUrl: './liberro-contact-detail.component.html',
  styleUrl: './liberro-contact-detail.component.less'
})
export class LiberroContactDetailComponent {
  @Input() public icon = '';
  @Input() public label = '';
  @Input() public value = '';
  @Input() public type: 'email' | 'phone' | 'text' = 'text';
}
